import { useForm } from 'react-hook-form';
import APIS from '../../constant/EndPoint';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
//@ts-ignore
import { useEffect, useState } from 'react';
import { getApiData } from '../../helpers/AxiosInstance';
import Button from '../Reusable/Button';
import Card from '../Reusable/Card';
import ComboboxInput from '../Reusable/ComboboxInput';
import TextField from '../Reusable/TextField';

const CreateTicket = (props: any) => {
  const { handleCreate, isLoading } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
    watch,
  } = useForm<any>({
    // resolver: yupResolver(createTicketValidationForm),
  });

  const subject = watch('queue');
  const [extraField, setExtraField] = useState([]);

  const handleAddForm = async (id: string) => {
    const url = `${APIS.TICKET_QUEUE}${id}/`;
    try {
      const res = await getApiData(url);
      if (res?.status === 200) {
        setExtraField(res?.data?.extra_data);
        // setValue('extra_data', res?.data?.extra_data);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleSetDefaultValue = async (id: string) => {
    const url = `${APIS.TICKET}extra-data/`;
    const param = {
      queue: id,
    };
    try {
      const res = await getApiData(url, param);
      if (res?.status === 200) {
        // setExtraField(res?.data?.extra_data);
        setValue('extra_data', res?.data?.results);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (subject) {
      handleAddForm(subject?.id ?? subject);
      handleSetDefaultValue(subject?.id ?? subject);
    }
  }, [subject]);

  return (
    <Card>
      <form onSubmit={handleSubmit((data) => handleCreate(data, setError))}>
        <div className={tw`grid grid-cols-2 gap-2 px-4`}>
          <ComboboxInput
            url={`${APIS.TICKET_QUEUE}`}
            queryKey={'queue'}
            register={register('queue', { required: 'Subject is required' })}
            errors={errors?.queue}
            name={'queue'}
            label={'Subject'}
            props={{ is_active: true }}
            setValue={setValue}
            placeholder={'Search Subject'}
            getValues={getValues}
            clearErrors={clearErrors}
          />

          <ComboboxInput
            url={`${APIS.TICKET}available-priority/`}
            queryKey={'priority'}
            register={register('priority', {
              required: 'Priority is required',
            })}
            errors={errors?.priority}
            props={{ is_active: true }}
            name={'priority'}
            label={'Priority'}
            setValue={setValue}
            placeholder={'Search priority'}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          {Array.isArray(extraField) && extraField?.length > 0
            ? extraField?.map((item: any, index: number) => {
                return item?.type === 'text' ? (
                  <TextField
                    key={item?.label}
                    register={register(
                      `extra_data.${[index]}.value`,
                      item?.required
                        ? {
                            required: `${item?.label} field is required`,
                          }
                        : {}
                    )}
                    //@ts-ignore
                    errors={errors?.extra_data?.[index]?.value}
                    label={item?.label}
                  />
                ) : (
                  <div
                    key={item?.label}
                    className={tw`w-full my-2 text-left mt-4`}
                  >
                    <label htmlFor={item?.label} className={tw`capitalize`}>
                      {item?.label}
                    </label>
                    <input
                      type='text'
                      id={item?.label}
                      {...register(
                        `extra_data.${[index]}.value`,
                        item?.required
                          ? {
                              required: `${item?.label} field is required`,
                            }
                          : {}
                      )}
                      maxLength={255}
                      className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                    />
                    {errors?.extra_data?.[index]?.value && (
                      <p className={tw`text-red-500 text-xs my-1`}>
                        {errors?.extra_data?.[index]?.value?.message}
                      </p>
                    )}
                  </div>
                );
              })
            : null}
        </div>
        <div className={tw`mt-4 px-4`}>
          <label htmlFor='description'>Description</label>
          <textarea
            id='description'
            rows={6}
            {...register('description', {
              required: 'Description is required',
            })}
            className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
            placeholder='Write a comment...'
          ></textarea>
          {errors?.description && (
            <p className={tw`text-red-500 text-xs my-1`}>
              {errors?.description?.message}
            </p>
          )}
        </div>
        <div className={tw`w-24 ml-auto mr-4`}>
          <Button label={'Create'} isLoading={isLoading} />
        </div>
      </form>
    </Card>
  );
};

export default CreateTicket;
